import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';

// Link base con headers estáticos
const httpLink = new HttpLink({
  // uri: 'https://intermediate.smartreport.cl/',
  uri: process.env.REACT_APP_GRAPHQL_URI,
  credentials: 'include'
});

// Link para headers dinámicos
const authLink = new ApolloLink((operation, forward) => {
  // Obtener el token y displayname del localStorage
  const token = localStorage.getItem('token');
  const displayname = localStorage.getItem('displayname');

  // Agregar headers a la operación
  operation.setContext({
    headers: {
      'language': 'es',
      ...(displayname && { 'displayname': displayname }),
      ...(token && { 'authorization': `Bearer ${token}` })
    }
  });

  return forward(operation);
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only'
    },
    query: {
      fetchPolicy: 'network-only'
    }
  }
});
